import fetch from 'isomorphic-fetch';
import ENV from '../environments/environment'


const userService = {
   async getUserData() {
     const response = await fetch( ENV.getGrabilityUrl() + "application-users" , { headers: ENV.getGrabilityHeaders() });
     return await response.json();
   } ,

   async addAddress(address) {
     address = JSON.stringify(address);
     const response = await fetch( ENV.getGrabilityUrl() + "application-users/address" ,{ headers: ENV.getGrabilityHeaders() ,  method: "POST", body: address });
     return await response.json();
   },

   async getUser(phone) {
     const response = await fetch(ENV.lupita_url + 'users/search/' + '?query=' + phone + '&type=' + 'phone' + '&module=call' ,{ headers: ENV.getLupitaHeaders()  });
     return await response.json();
   },

   async getUserByEmail(email) {
     const response = await fetch(ENV.lupita_url + 'users/search/' + '?query=' + email + '&type=' + 'email' + '&module=call' ,{ headers: ENV.getLupitaHeaders()  });
     return await response.json();
   },

   async createUser(user) {
     let newUser = {
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      phone: user.phone,
      gender: 'm',
     }
    const response = await fetch(ENV.lupita_landing_url + "user/create",{ headers: ENV.getLupitaHeaders() , method: 'POST', body: JSON.stringify(newUser) });
    return await response.json();
   },

  async getUserCards() {
    let endpoint;
    if(localStorage.getItem('country') === 'co') {
      endpoint = 'paymentez/cc?env=pro';
    } else {
      endpoint = 'payment/card'
    }
    const response = await fetch( ENV.getGrabilityUrl() + endpoint , { headers: ENV.getGrabilityHeaders() });
    return await response.json();
  } ,

  async addCard(data) {
    let card = { card: {
      cvc: data.cvc,
      exp_month: data.exp_month,
      exp_year: data.exp_year,
      name: data.name,
      number: data.number
      } }
      let params = JSON.stringify(card);
      const response = await fetch(ENV.conekta_url,{ headers: ENV.getConektaHeaders() , method: 'POST', body: params });
      return await response.json();
   },

   async assingCard(number , id) {
      let bin = number.substring(0,6)
      bin = bin.replace(" ", "");
      let data = {
        bin: bin,
        token: id
      }
      let params = JSON.stringify(data);
      const response = await fetch( ENV.getGrabilityUrl() + "payment/assign-card",{ headers: ENV.getGrabilityHeaders() ,  method: 'POST', body: params });
      return await response.json();
   },

  async setDefaultCC(id) {
   let data = {
     default_cc: id
   }
   let params = JSON.stringify(data);
   const response = await fetch( ENV.getGrabilityUrl() + "application-users", { headers: ENV.getGrabilityHeaders(),  method: 'PUT', body: params});
   return await response.json();

 },

  async getAddCardUrl() {
    const response = await fetch( "https://api69.rappi.com/api/paymentez/cc/url-add?env=pro", { headers: ENV.getGrabilityHeaders() } );
    return await response.json();
  }


}

export default userService;



// WEBPACK FOOTER //
// ./src/services/user.service.js